//upload file
//as multipart form data
export async function uploadFile(URL, file) {
  //return
  return new Promise(async (resolve, reject) => {
    //get the access token from local storage
    var accessToken = localStorage.getItem("access_token");
    accessToken =
      accessToken !== null && accessToken !== "undefined" ? accessToken : "";

    //form data
    const formData = new FormData();
    // 'uploadedFiles' here should match the name expected by the PHP script ($_FILES['uploadedFiles'])
    formData.append("file", file);

    //fetch
    await fetch(URL, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`, // if needed
      },
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        //resolve
        resolve(data);
        console.log("Response: ", data);
      })
      .catch((e) => {
        //resolve
        resolve(null);
        console.error("Error: ", e);
      });
  });
}

//create api request
//method POST, GET
//content_type
//param_obj = {arg: val}
export async function createAPIRequest(URL, method, content_type, param_obj) {
  //return
  return new Promise(async (resolve, reject) => {
    //get the access token from local storage
    var accessToken = localStorage.getItem("access_token");
    accessToken =
      accessToken !== null && accessToken !== "undefined" ? accessToken : "";

    //fetch the status from the API
    await fetch(URL, {
      method: method,
      headers: {
        "Content-Type": content_type,
        Authorization: `Bearer ${accessToken}`, // if needed
      },
      body: JSON.stringify(param_obj),
    })
      .then((response) => response.json())
      .then((data) => {
        //callback
        resolve(data);
        console.log("Response Data:", data);
      })
      .catch((error) => {
        //callback
        resolve(null);
        console.error("Error:", error);
      });
  });
}

//get signed aws url
//to download file
//aws_file_name = file name at aws bucket
export async function getSignedAWSS3URLToDownloadFile(URL, aws_file_name) {
  //create request
  const response = await createAPIRequest(URL, "POST", "application/json", {
    request_type: "SIGN_AWS_URL_TO_DOWNLOAD_FILE",
    fileName: aws_file_name,
  });

  //return
  return response;
}

//get signed aws url
//to upload file
export async function getSignedAWSS3URLToUploadFile(URL, file) {
  //check
  if (file === null) {
    //return
    return "";
  }

  //create request
  const response = await createAPIRequest(URL, "POST", "application/json", {
    request_type: "SIGN_AWS_URL_TO_UPLOAD_FILE",
    fileName: file.name,
    contentType: file.type,
  });

  //return
  return response;
}

//upload file to aws s3 sever
//as multipart form data
//always upload using PUT request
//also mention the content type header it should match the signed url content type
//url = aws signed url
export async function uploadFileToAWSS3Server(URL, file) {
  //return
  return new Promise(async (resolve, reject) => {
    //fetch
    await fetch(URL, {
      method: "PUT",
      body: file, // Send the raw file data as the body
      headers: {
        "Content-Type": file.type, // Must match the Content-Type used in signed URL generation
      },
    })
      .then((data) => {
        //resolve
        resolve(data);
        console.log("Response: ", data);
      })
      .catch((e) => {
        //resolve
        resolve(null);
        console.error("Error: ", e);
      });
  });
}
